module.exports = __webpack_public_path__ + "img/oldskool-uk.2abd43d1.png";